/**
 * Lightweight logging helpers for the frontend.
 *
 * `debugLog`/`debugError` are gated on `import.meta.env.DEV`, which Vite
 * statically replaces with `false` in production builds. The guarded
 * `if (import.meta.env.DEV)` branch is then dead-code-eliminated, so these
 * calls emit nothing in production bundles. Use them for diagnostic traces
 * that must never reach the production console (SEC-017 / CWE-532).
 *
 * `securityWarn` is intentionally NOT gated — it always emits via
 * `console.warn`. Use it for security-relevant events (e.g. a rejected auth
 * callback) that should remain observable in production. NEVER pass secret
 * values (tokens, credentials, nonces) to it — log only the fact of the event.
 */

/** Development-only `console.log`. Stripped from production builds. */
export function debugLog(...args: unknown[]): void {
  if (import.meta.env.DEV) {
    console.log(...args);
  }
}

/** Development-only `console.error`. Stripped from production builds. */
export function debugError(...args: unknown[]): void {
  if (import.meta.env.DEV) {
    console.error(...args);
  }
}

/**
 * Always-on security warning. Survives production builds so security events
 * stay observable. Pass only non-sensitive context — never secret values.
 */
export function securityWarn(...args: unknown[]): void {
  console.warn(...args);
}
